import { meetingLinkOrderApi, orderApi } from '@/core/api/order'

export const {
  useGetMeetingLinkOrdersQuery,
  useLazyGetMeetingLinkOrdersQuery,
  useUpdateMeetingLinkOrderMutation,
  useAcceptMeetingLinkOrderMutation,
  useRefuseMeetingLinkOrderMutation,
} = meetingLinkOrderApi

export const {
  useGetOrderByReferenceIdQuery,
  useGetOrdersQuery,
  useGetConsultationOrdersQuery,
  useGetExpertiseOrdersQuery,
  useSearchOrdersQuery,
  useLazySearchOrdersQuery,
  useUpdateOrderMutation,
  useUpdateConsultationOrderMutation,
  useAcceptConsultationOrderMutation,
  useAcceptExpertiseOrderMutation,
} = orderApi
